<mat-card class="example-card" style="padding:0" id="dashboard-css">
    <mat-card-content class="main-page-content dashboard-content">
        <div class="row" *ngIf="loggedInUserTypeId != userTypes.SUPER_ADMIN && loggedInUserTypeId != userTypes.Manager">
            <div class="col-sm-12">
                <div class="col-sm-6">
                    <h5>Assigned Checks</h5>
                </div>
                <div class="row">
                    <ng-container *ngFor="let check of checks">
                        <ng-container *ngIf="getTotalCount(check.checkTypeId) > 0">
                            <div class="col-sm-3" style="margin-bottom: 3px;">
                                <mat-accordion class="custom-accordion">
                                    <mat-expansion-panel class="custom-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                {{ check.checkName }} (Total: {{ getTotalCount(check.checkTypeId) }})
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <table mat-table [dataSource]="statusCounts[check.checkTypeId]"
                                            class="mat-elevation-z8 custom-table">
                                            <ng-container matColumnDef="statusName">
                                                <th mat-header-cell *matHeaderCellDef > Status Name </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <a href="javascript:void(0)" (click)="navigateToProfileScreen(element.statusId, check.checkTypeId)">
                                                      {{element.statusName}}
                                                    </a>
                                                  </td>
                                                  
                                            </ng-container>
                                            <ng-container matColumnDef="count">
                                                <th mat-header-cell *matHeaderCellDef> Count </th>
                                                <td mat-cell *matCellDef="let element"> {{element.count}} </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="['statusName', 'count']"></tr>
                                            <tr mat-row *matRowDef="let row; columns: ['statusName', 'count'];"></tr>
                                        </table>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </ng-container>
                    </ng-container>
                                      
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>